export const topicClusters = [
  {
    slug: 'robot-vacuum-cleaners',
    name: 'Robot Vacuum Cleaners',
    description: 'Buying guides, cost comparisons and care advice for robot vacuum-mops in Indian homes.',
    postSlugs: ['best-robot-vacuum-cleaners-indian-homes-2025', 'how-to-choose-right-robot-vacuum-indian-homes', 'robot-vacuum-maintenance-tips-long-life', 'robot-vacuum-vs-maid-cost-comparison-india', 'best-robot-vacuum-pet-hair-india', 'robot-vacuum-marble-floors-india', 'self-emptying-robot-vacuum-worth-it', 'cleaning-robots-monsoon-care-guide-india'],
    link: '/floor-cleaning-robots',
  },
  {
    slug: 'window-cleaning-robots',
    name: 'Window Cleaning Robots',
    description: 'How window robots work, safety systems, and cost versus professional glass cleaning.',
    postSlugs: ['window-cleaning-robots-high-rise-buildings-india', 'window-cleaning-robot-safety-features-explained', 'window-robot-vs-professional-cleaners-cost', 'how-window-cleaning-robots-work'],
    link: '/window-cleaning-robots',
  },
  {
    slug: 'pool-cleaning-robots',
    name: 'Pool Cleaning Robots',
    description: 'Pool maintenance costs, algae prevention, energy savings and robotic pool care for villas and hotels.',
    postSlugs: ['best-pool-cleaning-robots-hotels-india-2025', 'manual-vs-robotic-pool-cleaning-cost-comparison', 'commercial-pool-maintenance-guide-india', 'pool-cleaning-robot-buying-guide-india', 'pool-robot-energy-savings-india', 'how-often-clean-swimming-pool-india', 'prevent-algae-pool-cleaning-robots'],
    link: '/pool-cleaning-robots',
  },
  {
    slug: 'commercial-cleaning-robots',
    name: 'Commercial Cleaning Robots',
    description: 'ROI models and deployment guides for offices, hotels, hospitals, warehouses and restaurants.',
    postSlugs: ['commercial-cleaning-robots-offices-hospitals-india', 'how-robotic-cleaning-transforming-hotel-maintenance', 'cleaning-robots-for-hospitals-hygiene-guide', 'cleaning-robots-restaurants-cafes-india', 'warehouse-dust-control-cleaning-robots', 'office-cleaning-robots-roi-india'],
    link: '/commercial-floor-cleaning-robots',
  },
  {
    slug: 'smart-home-automation',
    name: 'Smart Home Automation',
    description: 'Voice control, scheduling and integrating cleaning robots into the connected Indian home.',
    postSlugs: ['smart-home-automation-cleaning-robots-india', 'voice-control-cleaning-robots-alexa-google', 'robot-cleaning-schedule-best-practices', 'luxury-villa-cleaning-automation-guide'],
    link: '/smart-home-robots',
  },
  {
    slug: 'ai-robotics',
    name: 'AI Robotics',
    description: 'The technology inside: LiDAR, SLAM, AI object recognition, RTK navigation and what comes next.',
    postSlugs: ['ai-cleaning-technology-lidar-navigation-explained', 'how-ai-object-recognition-works-cleaning-robots', 'rtk-navigation-robotic-lawn-mowers-explained', 'robotic-lawn-mowers-villas-farmhouses-india', 'future-of-cleaning-robots-india-trends-2025', 'home-robotics-india-2027-outlook'],
    link: '/ai-cleaning-robots',
  },
];
